import { whenNot } from 'platform/shared/health-apps';
import {
  includeAgentOrangeExposure,
  includeGulfWarService,
  includeGulfWarServiceDates,
  includeOtherExposureDates,
  includeOtherExposureDetails,
  includePostSept11Service,
  includePostSept11ServiceDates,
  includeRadiationCleanUpEfforts,
  includeTeraInformation,
  isShortFormEligible,
} from '../../../utils/helpers';
import { dischargePapersPages } from './dischargePapers';
import servicePeriod from './servicePeriods/lastServicePeriod';
import serviceHistory from './servicePeriods/serviceHistory';
import agentOrangeExposure from './tera/agentOrangeExposure';
import combatOperationService from './tera/combatOperationService';
import gulfWarService from './tera/gulfWarService';
import gulfWarServiceDates from './tera/gulfWarServiceDates';
import otherToxicExposure from './tera/otherToxicExposure';
import otherToxicExposureDates from './tera/otherToxicExposureDates';
import otherToxicExposureDetails from './tera/otherToxicExposureDetails';
import postSept11Service from './tera/postSept11Service';
import postSept11ServiceDates from './tera/postSept11ServiceDates';
import radiationCleanup from './tera/radiationCleanup';
import toxicExposure from './tera/toxicExposure';

export const militaryServicePages = {
  serviceInformation: {
    path: 'military-service/service-information',
    title: 'Service periods',
    depends: whenNot(isShortFormEligible),
    ...servicePeriod,
  },
  additionalInformation: {
    path: 'military-service/additional-information',
    title: 'Service history',
    depends: whenNot(isShortFormEligible),
    ...serviceHistory,
  },
  toxicExposure: {
    path: 'military-service/toxic-exposure',
    title: 'Toxic exposure',
    ...toxicExposure,
  },
  radiationCleanup: {
    path: 'military-service/radiation-cleanup-efforts',
    title: 'Radiation cleanup or response efforts',
    depends: includeRadiationCleanUpEfforts,
    ...radiationCleanup,
  },
  gulfWarService: {
    path: 'military-service/gulf-war-service',
    title: 'Service after August 2, 1990',
    depends: includeGulfWarService,
    ...gulfWarService,
  },
  gulfWarServiceDates: {
    path: 'military-service/gulf-war-service-dates',
    title: 'Service dates after August 2, 1990',
    depends: includeGulfWarServiceDates,
    ...gulfWarServiceDates,
  },
  postSept11Service: {
    path: 'military-service/post-sept-11-service',
    title: 'Service post-9/11',
    depends: includePostSept11Service,
    ...postSept11Service,
  },
  postSept11ServiceDates: {
    path: 'military-service/post-sept-11-service-dates',
    title: 'Post-9/11 service dates',
    depends: includePostSept11ServiceDates,
    ...postSept11ServiceDates,
  },
  combatOperationService: {
    path: 'military-service/operation-support',
    title: 'Operations',
    depends: includeTeraInformation,
    ...combatOperationService,
  },
  agentOrangeExposure: {
    path: 'military-service/agent-orange-exposure',
    title: 'Agent Orange exposure',
    depends: includeAgentOrangeExposure,
    ...agentOrangeExposure,
  },
  otherToxicExposure: {
    path: 'military-service/other-toxic-exposure',
    title: 'Other toxic exposures',
    depends: includeTeraInformation,
    ...otherToxicExposure,
  },
  otherToxicExposureDetails: {
    path: 'military-service/other-toxins-or-hazards',
    title: 'Other toxin or hazard exposure',
    depends: includeOtherExposureDetails,
    ...otherToxicExposureDetails,
  },
  otherToxicExposureDates: {
    path: 'military-service/other-toxic-exposure-dates',
    title: 'Other toxic exposure dates',
    depends: includeOtherExposureDates,
    ...otherToxicExposureDates,
  },
  ...dischargePapersPages,
};
